import { endGuestType, endHostType, joinGuestType, joinHostType, responseTypes, roomDType, updatePeersType } from "@/modules";
import { NOAUTHPOST, POSTWITHAUTH } from "./blueprint";
import ENDPOINTS from "@/Configs/Endpoints";

export const googleAuth = async ({ token }: { token: string }): Promise<responseTypes> => {
    try {
        const data = await NOAUTHPOST({ data: { token: token }, endPoint: ENDPOINTS.auth });
        if (data.success && data.data && data.data.token) {
            return { success: true, message: "", data: { token: data.data.token, userDetails: data.data.result } }
        }
        return { success: data.success, message: data.message, data: data.data }
    } catch (error) {
        console.log(error)
    }
    return { success: false, message: "Error, try again", data: { token: "", userDetails: {} } }
}

export const checkIp = async (): Promise<responseTypes> => {
    try {
        const data = await POSTWITHAUTH({ data: {}, endPoint: ENDPOINTS.checkIp });
        if (data.success && data.data && data.data.token) {
            return { success: true, message: "", data: { token: data.data.token, userDetails: data.data.result } }
        }
        return { success: data.success, message: data.message, data: data.data }
    } catch (error) {
        console.log(error)
    }
    return { success: false, message: "Error, try again", data: { token: "", userDetails: {} } }
}